import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useOutletContext } from "react-router-dom";
import { Pagination, Autoplay } from 'swiper/modules';

import { ArticleButton } from "../Helper";
import Link from "../../../components/Link";
import Popup from "./Popup";
import Title from "../../../components/Title";
import Slider from "../../../components/Slider";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import ReadTime from "../../../components/ReadTime";
import DialogBox from "../../../components/DialogBox";
import Background from "../../../components/Background";
import CategoryList from "../../../components/CategoryList";

import style from "./style.module.css";

export default function ArticleBanner({ article = [], autoplay = false, delay = 10000, shadow = 0 }) {

	const { winHeight } = useOutletContext();
	const swiperRef = useRef(null);
	const [popup, setPopup] = useState(false);

	let modules = [Pagination];
	if (autoplay === true) {
		modules.push(Autoplay);
	}

	return (
		<>
			{
				(article || []).length > 0 && (
					<Slider className={`articleBannerSlider ${style.articleBannerSlider}`} swiperRef={swiperRef} autoplay={autoplay}>
						<Swiper
							ref={swiperRef}
							modules={modules}
							autoplay={{ delay }}
							spaceBetween={0}
							slidesPerView={1}
							pagination={{
								clickable: true,
								bulletClass: style.swiperPaginationBullet,
								bulletActiveClass: style.swiperPaginationBulletActive,
								el: `.${style.swiperPagination}`,
							}}
						>
							{
								article.map((item, index) => {
									return (
										<SwiperSlide key={`article_sliderItem_${index}`} className={`${style.sliderItem} ${shadow === 1 ? style.shadowBg : ""}`}>
											<div className={style.slider} style={winHeight ? { minHeight: `${winHeight}px` } : undefined}>
												<Link className={style.fullBlock} to={`/article/${item.url}`}></Link>
												<Background src={item.preview_image} size="2560x1440" />
												<Section className={style.articleBanner}>
													<div className={style.sectionTextContent}>
														<Title className="bigTitle">{item.name}</Title>
														<div className={`${style.categoryList} ${style.categoryListLast}`}>
															{
																(item.categories || []).length > 0 && (
																	<CategoryList item={item.categories} type="category" />
																)
															}
															{
																(item.series || []).length > 0 && (
																	<CategoryList item={item.series} />
																)
															}
														</div>
														<div className={`${style.description} ${style.shortDescription}`}>
															<Editor text={item.short_description} />
														</div>
														<div className={`${style.timeDuration}`}>
															<ReadTime type="bold" time={item.time_duration} />
														</div>
														<div className={style.buttonRow}>
															<ArticleButton type={item.media_type} url={item.url} />
															<ArticleButton onClick={() => setPopup(item.url)} buttonColor="buttonSecondary" />
														</div>
													</div>
												</Section>
											</div>
										</SwiperSlide>
									)
								})
							}
							<div className={style.swiperPagination}></div>
						</Swiper>
					</Slider>
				)
			}
			{
				(popup !== false && popup !== null) && (
					<DialogBox
						onClose={() => setPopup(false)}
						className={`${style.articlePopup}`}
						title={false}
						headerClass={style.dialogBoxHeader}
						modalClassName={style.articleModal}
						render={() => {
							return (
								<Popup articleUrl={`article/${popup}`} />
							)
						}}
					/>

				)
			}
		</>
	)
}